import formatarValorTooltip from "../../helpers/formatarDadosGrafico";
import { GraficoComponenteProps } from "../../interfaces/dashboardCard"
import { chavesValoresSiglas } from "../../interfaces/indicadorMensuracao";
import "./graficoCard.css"

function GraficoCard({ indicador, Icon, onClick }: GraficoComponenteProps) {

  const { indicadoresMensuracaos, sigla } = indicador;

  const siglaChave = sigla.toLowerCase() as keyof chavesValoresSiglas;
  const valores = indicadoresMensuracaos
    .map(dado => Number(dado[siglaChave]))
    .filter(valor => !isNaN(valor));

  const ultimoValor = valores[valores.length - 1]
  return (
    <div className='dadosDashboardGraficoCard' onClick={onClick}>
      <div className='dashboardContent'>
        <h1>{indicador.titulo}</h1>
        <p>{formatarValorTooltip(siglaChave, ultimoValor)}</p>
        <p>{indicador.insight}</p>
      </div>
      <div>
        {Icon && <Icon fontSize={"70px"} color="#FF6B6C" />}
      </div>
    </div>
  );
}

export default GraficoCard;